<template>
    <div>
        <promotion-form :entity-id="entityId"></promotion-form>
    </div>
</template>

<script>
import PromotionForm from '@/components/pages/promotion/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        PromotionForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
